import axios from 'axios';
import EnvWindow from '../../utils/env';

export async function deleteExam(examId: string | null): Promise<unknown> {
  const response = await axios.delete(
    `${EnvWindow.REACT_APP_EXAMS_API_URL}/Exams/${examId}`
  );
  return response.data;
}
